var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vg_emailVerified)?_c('section',{staticClass:"email-verified-notice"},[_c('p',[_vm._v("Great news, Your email has been confirmed!")]),_c('span',{staticClass:"close-email-verified-notice",on:{"click":function($event){return _vm.va_setEmailVerified()}}},[_c('i',{staticClass:"fas fa-times"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }